<template>
  <div>
    <v-app-bar flat color="#f9f9f9" height="65">
      <div class="container" id="main-nav-container">
        <v-app-bar-nav-icon @click="showSideNav" id="side-nav-toggle-button"/>
        <img class="logo" src="../../assets/img/logo/logo.svg" alt="Lupfen.de Logo" title="Lupfen.de Logo">
        <div class="title ml-2 mt-1 mr-4">Lupfen.de</div>
        <v-spacer></v-spacer>

        <div class="mt-1" id="main-nav-links">
          <v-btn v-for="item in menuItems" :key="item.title" text :to="item.link" color="#494949">
            <v-icon left>{{ item.icon }}</v-icon>
            {{ item.text }}
          </v-btn>

          <v-menu v-if="loggedInUser" offset-y transition="slide-y-transition">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on" color="#494949">
                <v-icon left>mdi-account-circle</v-icon>
                {{ loggedInUser.displayName }}
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="routeToProfile">
                <v-list-item-icon>
                  <v-icon>mdi-account-cog-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Profil</v-list-item-title>
              </v-list-item>

              <v-list-item @click="logout">
                <v-list-item-icon>
                  <v-icon>mdi-logout-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn v-else text to="/anmelden" color="#494949">
            <v-icon left dark>mdi-login-variant</v-icon>
            Anmelden
          </v-btn>
        </div>
      </div>
    </v-app-bar>

    <SideNav :logged-in-user="loggedInUser"
             :menu-items="menuItems"
             @route-to-profile="routeToProfile"
             @logout="logout"/>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import {NavigationRoutes} from "@/ui/router";
  import {AuthService} from "@/application/service/AuthService";
  import {showSuccess} from "@/ui/notification";
  import SideNav from "@/ui/components/layout/SideNav";

  export default {
    name: "MainNav",
    components: {SideNav},
    data() {
      return {
        menuItems: [
          {icon: 'mdi-home', text: 'Home', link: '/'},
          {icon: 'mdi-play', text: 'Spielen', link: '/spielen'},
          {icon: 'mdi-clipboard-list', text: 'Regeln', link: '/regeln'},
        ]
      }
    },
    computed: {
      ...mapGetters({
        loggedInUser: "loggedInUser"
      })
    },
    methods: {
      showSideNav() {
        this.$emit('show-side-nav');
      },
      routeToProfile() {
        if (this.$route.name !== NavigationRoutes.Profile)
          this.$router.push({name: NavigationRoutes.Profile})
      },
      async logout() {
        await this.$router.push({name: NavigationRoutes.Auth})
        await AuthService.logout();
        showSuccess('Du hast dich erfolgreich abgemeldet');
      }
    }
  }
</script>

<style scoped>
  #main-nav-container {
    display: flex;
    color: #494949;
    border-bottom: 1px solid #e0e0e0;
  }

  .logo {
    height: 41px;
  }
</style>
